
import store from '@/store'

window.dragBlockStatu =false;
export  const  DRAG_BLOCK =()=>{
  store.state.dragBlockStatu =true;
  // console.log('拖拽开始')
}
export  const  END_DRAG_BLOCK =()=>{
  store.state.dragBlockStatu =false;
}
